import Parameters from '@/app/shared/models/Parameters'
import moment from 'moment'

class MassiveDownloadPost {
  constructor ({ selectedGranularity, selectedDateFrom, selectedDateTo, selectedProductDimensionIds, selectedStoreDimensionIds, selectedProductFilters, selectedStoreFilters, selectedStoreProductDimensionIds, stock }) {
    this.granularity = selectedGranularity
    this.dateFrom = moment(selectedDateFrom).format('YYYYMMDD')
    this.dateTo = moment(selectedDateTo).format('YYYYMMDD')
    this.productDimensionIds = selectedProductDimensionIds
    this.storeDimensionIds = selectedStoreDimensionIds
    this.storeProductDimensionIds = selectedStoreProductDimensionIds
    this.productFilters = selectedProductFilters
    this.storeFilters = selectedStoreFilters
    this.stock = stock
  }

  get parameters () {
    const fixedMetricsNormal = [
      'quantity_sold',
      'real_sales_cost',
      'real_sales_amount',
      'stock_quantity',
      'real_margin',
      'real_stock_pvp_amount',
      'real_stock_cost_amount',
      'transfer_quantity'
    ]
    const dateDimensions = this.granularity.dateFromField ? ['date_from'] : []
    return new Parameters.ParametersBuilder()
      .withStoreFilters(this.storeFilters)
      .withProductFilters(this.productFilters)
      .withStoreDimensions(this.storeDimensionIds)
      .withProductDimensions(this.productDimensionIds)
      .withStoreProductDimensions(this.storeProductDimensionIds)
      .withDateDimensions(dateDimensions)
      .withMetrics({ normal: fixedMetricsNormal, var: [] })
      .withStock(this.stock)
      .withFact({ type: 'table', name: this.granularity.factTable })
      .withDateFilters({ date: { operator: 'BT', value: [this.dateFrom, this.dateTo] } })
      .withSort({ field: 'quantity_sold', dir: 'desc' })
      .withGranularity(this.granularity)
      .build()
  }
}

export default MassiveDownloadPost



// WEBPACK FOOTER //
// ./src/app/massive_download/models/MassiveDownloadPost.js